module.exports = __webpack_public_path__ + "img/img4c.ebfeed6a.png";